import { render, staticRenderFns } from "./OHeaderImage.vue?vue&type=template&id=09ca7130&"
import script from "./OHeaderImage.vue?vue&type=script&lang=js&"
export * from "./OHeaderImage.vue?vue&type=script&lang=js&"
import style0 from "./OHeaderImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports